import React from 'react';
import Wallitem from './WallItem';
import { postData, getUrlParameter, translation, postLikedDislikedCT } from '../../utils/helper';
import $ from 'jquery';
import { listApiStore } from '../../config/store';

export default class WallList extends React.Component {
    constructor() {
        super();
        this.state = {
            list: [],
            sorting: null,
            padding: "",
            index: 1,
            sorting: "most-liked",
            size: 10,
            activeImage: null,
            listshow: true
        }
    }
    componentDidMount() {

        listApiStore.subscribe(() => {
            let getData = listApiStore.getState().data;
            if (getData) {
                this.setState({ index: 1 }, () => {
                    this.getWallList();

                })
            }
        })

        this.getWallList();
        var ref = this;
        $(window).unbind("scroll");
        $(window).scroll(function () {

            if ($(window).scrollTop() >= $(document).height() - $(window).height() - 100 && ref.state.listshow) {
                ref.setState({ index: ref.state.index + 1 }, () => {
                    ref.getWallList(ref.state.sorting);
                })
            }

            if ($(window).scrollTop() >= 200) {
                $(".icon_camera_closed_js").fadeIn();
            } else {
                $(".icon_camera_closed_js").fadeOut();
            }

        });
    }
    getWallList = () => {

        var params = {};
        params['index'] = this.state.index;
        params['sort_by'] = this.state.sorting;
        params['module_subtype'] = this.props.module_name;
        params['page_size'] = this.state.size;
        params['ew_v'] = 2;

        postData(params, 'walllist', 'noloader').done((response) => {
            if (response.data && response.data.length > 0) {
                this.setListing(response.data, params['sort_by']);
            } else if (response.data && response.data.data && response.data.data.length > 0) {
                this.setListing(response.data.data, params['sort_by']);
            } else {
                this.setState({ listshow: false });
            }
        })
    }
    setListing(list, sorting) {

        var viewPort = getUrlParameter('view');
        if (viewPort != "webview") {
            var old_list = this.state.list;
            if (this.state.index != 1) {
                this.setState({ "list": old_list.concat(list) });
            } else {
                this.setState({ "list": list, "sorting": sorting });
            }

        }

    }
    sortList(sorting) {

        this.setState({ "sorting": sorting, "index": 1 }, () => {
            this.getWallList();
        })
    }
    likedislike(post_id, elem) {
        var params = {};
        if (elem) {
            elem.persist();
        }
        var parameter = elem.target.getAttribute("attr-parameter");
        var countlike = $("#count_id_" + post_id).text();

        var id = post_id;
        if (parameter == null) {
            parameter = "Like";
        }
        params['postid'] = id;
        params['like'] = parameter;
        let user_id = getUrlParameter('userid');
        params['userid']= user_id

        postData(params, 'postlike', 'noloader').done((data) => {
            if (data.message == "User like successfully") {
                var newCount = parseInt(countlike);
                newCount++;
                elem.target.setAttribute("attr-parameter", "unlike");
                elem.target.setAttribute("src", "/assets/img/liked1.png");
                $(elem.target).parent().removeClass('article_like_default');
                $(elem.target).parent().addClass('article_like_active');
                $("#count_id_" + post_id).text(newCount);
                postLikedDislikedCT({
                    type: "liked",
                    postid: id
                });
            } else if (data.message == "Post unlike successfully" || data.message == "Post does not exists in our database" || data.message == "Fail") {
                var newCount = parseInt(countlike);
                newCount--
                elem.target.setAttribute("attr-parameter", "like");
                elem.target.setAttribute("src", "/assets/img/like.png");
                $(elem.target).parent().removeClass('article_like_active');
                $(elem.target).parent().addClass('article_like_default');
                if (newCount < 0) {

                } else {
                    $("#count_id_" + post_id).text(newCount);
                }
                postLikedDislikedCT({
                    type: "unliked",
                    postid: id
                });
            }
        })
    }
    render() {
        var viewPort = getUrlParameter( 'view' );
        const { list, sorting } = this.state;
        if (viewPort != "webview") {
            return (
                <div>
                    <div className="tab_bg">
                        <div className="container">
                            <div className="tab_list">
                                <ul>
                                    <li className={sorting == 'most-liked' ? "active_tab" : ""} onClick={() => { this.sortList('most-liked') }}>
                                        <a href="javascript:void(0)">Most Liked</a>
                                    </li>
                                    <li className={sorting == 'latest' ? "active_tab" : ""} onClick={() => { this.sortList('latest') }}>
                                        <a href="javascript:void(0)">Most Recent</a>
                                    </li>
                                    <li className={sorting == 'all' ? "active_tab" : ""} onClick={() => { this.sortList('all') }}>
                                        <a href="javascript:void(0)">show all post</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="card_bg">
                        <div className="container">
                            {
                                list && list.length > 0 && list.map((value, index) => {
                                    return (

                                        <Wallitem key={value.id} likedislike={this.likedislike} value={value} />
                                    )
                                })
                            }

                        </div>
                    </div>

                </div>
            )
        } else {
            return null
        }
    }
}